module.exports = __webpack_public_path__ + "static/img/04.8e905f3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/travelpolicy/04.jpg
// module id = ol1p
// module chunks = 0